// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/box-list/pickup-switching.css
// module id = 13594
// module chunks = 0